module.exports = __webpack_public_path__ + "static/media/55554582_2519314731477036_1520564228333764608_o.26af8b81.jpg";